import React from 'react';
import { Button } from '../ui/Button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const HeroSection: React.FC = () => {
  return (
    <section id="hero" className="relative z-0 min-h-[80vh] md:min-h-[90vh] overflow-hidden bg-transparent">
      {/* Remove any potential background colors */}
      <div className="absolute inset-0 -z-40 bg-transparent"></div>
      
      {/* Background Image with subtle overlay - hidden on mobile, visible on desktop/tablet */}
      <div 
        className="hidden md:block absolute inset-0 z-[-20] bg-cover bg-top" 
        style={{
          // Fallback for browsers that don't support image-set
          backgroundImage: 'url("/images/optimized/hero.jpg")',
          // Modern browsers with image-set support
          ...(CSS.supports('background-image', 'image-set(url(test.jpg) 1x)') && {
            backgroundImage: `image-set(
              url("/images/optimized/hero.avif") type("image/avif") 1x,
              url("/images/optimized/hero.webp") type("image/webp") 1x,
              url("/images/optimized/hero.jpg") type("image/jpeg") 1x
            )`
          }),
          // Webkit prefix for Safari
          ...(CSS.supports('background-image', '-webkit-image-set(url(test.jpg) 1x)') && {
            backgroundImage: `-webkit-image-set(
              url("/images/optimized/hero.avif") 1x,
              url("/images/optimized/hero.webp") 1x,
              url("/images/optimized/hero.jpg") 1x
            )`
          })
        }}
      >
        {/* Light overlay */}
        <div className="absolute inset-0 bg-white/30"></div>
      </div>
      
      {/* Atmospheric lighting effects - increased size and coverage for mobile */}
      <div className="md:hidden absolute top-0 right-0 w-[150vw] h-[150vh] rounded-full bg-primary-500/10 blur-[120px] -z-10"></div>
      <div className="md:hidden absolute bottom-0 left-0 w-[150vw] h-[150vh] rounded-full bg-gray-300/20 blur-[120px] -z-10 translate-y-1/3"></div>
      
      {/* Main content - added bg-transparent to all elements */}
      <div className="relative z-10 container mx-auto px-4 text-center pt-44 pb-16 md:pb-48 bg-transparent">
        <h1 className="text-4xl md:text-6xl font-display font-bold mb-12 md:mb-16 leading-tight md:leading-tight text-gray-950 bg-transparent">
          Journal Your Trades in <span className="gradient-text bg-transparent">Seconds</span>,<br />
          Track Your Discipline and <span className="gradient-text bg-transparent">Habits</span>,<br />
          Get AI <span className="gradient-text bg-transparent">Insights</span>,<br />
          Win The Long <span className="gradient-text bg-transparent">Game</span>
        </h1>

        <div className="flex justify-center mb-8 md:mb-28 mt-4 bg-transparent">
          <Button 
            as={Link} 
            to="/trial" 
            className="!rounded-full px-8 py-4 text-lg font-semibold min-w-[240px] shadow-lg hover:shadow-xl flex flex-col items-center justify-center bg-black hover:bg-gray-900 text-white transition-all duration-300 animate-float shadow-glow"
          >
            <div className="flex items-center">
              Start your Free Trial
              <ArrowRight
                size={20}
                className="ml-3"
                aria-hidden="true"
                focusable="false"
              />
            </div>
            <span className="text-xs font-normal mt-1">No card needed</span>
          </Button>
        </div>
      </div>
      
      {/* Add a fully transparent overlay to override any parent backgrounds */}
      <div className="md:hidden absolute inset-0 -z-30 bg-transparent"></div>
    </section>
  );
};